import { ref, computed, readonly } from 'vue'
import useTimer from '../timer'
import type { NotificationDetails } from '@/types'

type Notification = NotificationDetails & {
    id: symbol
}

const { startTimer, resetTimer } = useTimer(4, () => closeNotification())
const notifications = ref<Notification[]>([])
const notificationsOnHold = ref<Notification[]>([])
const currentNotificationSymbol = ref<symbol | null>(null)
const currentNotification = computed(() => notifications.value.find((n) => n.id === currentNotificationSymbol.value))

const pushNotification = (notification: NotificationDetails) => {
    const id = Symbol('notification')

    const output = {
        ...notification,
        id,
    }

    if (currentNotificationSymbol.value) {
        notificationsOnHold.value.push(output)
    } else {
        startTimer()
        currentNotificationSymbol.value = id
        notifications.value.push(output)
    }
}

const closeNotification = () => {
    resetTimer()
    currentNotificationSymbol.value = null

    if (notificationsOnHold.value?.length) {
        const notification = notificationsOnHold.value.shift() as Notification
        pushNotification(notification)
    }
}

export default function useNotifications() {
    return {
        currentNotification: readonly(currentNotification),
        pushNotification,
        closeNotification,
    }
}
